import React from 'react';
import { motion } from 'framer-motion';
import { audiences } from '../data/site';
import { Icon } from '../utils/icons';
import { SectionHeading } from './SectionHeading';
export function WhoWeHelp() {
  return <section id="who-we-help" className="w-full bg-gray-50" data-id="element-187" data-mp="yxpzi6amko8k">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:py-24" data-id="element-188" data-mp="13vri6q452lji">
        <SectionHeading eyebrow="Who We Work With" title="Who We Help" data-id="element-189" data-mp="13w9ka3dhftzc" />

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-190" data-mp="1rmdczfp4u9bk">
          {audiences.map((item, index) => <motion.article key={item.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.06,
          ease: 'easeOut'
        }} className="group border border-gray-200 bg-white p-8 transition-colors hover:border-gold" data-id="element-191" data-mp="1wjvpth69t8ou" data-mpi={index}>
              <span className="flex h-12 w-12 items-center justify-center bg-navy transition-colors group-hover:bg-gold" data-id="element-192" data-mp="2fc7sk50u6bzi">
                <Icon name={item.icon} className="h-5 w-5 text-white" data-id="element-193" data-mp="2yac4t86978jy" />
              </span>
              <h3 className="mt-6 font-display text-lg font-extrabold uppercase tracking-wide text-navy" data-id="element-194" data-mp="2y8hipqj8xaea">
                {item.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-gray-600" data-id="element-195" data-mp="387q8063620ub">
                {item.description}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}